import React from "react"
import { motion } from 'framer-motion'
import { useEase } from '../motion'

export const TitleFuture = (props) => {

	const duration = 1

	const parentControl = {
		closed: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1.5,
				delayChildren: 1.35,
				staggerChildren: 0.1,
				when: 'afterChildren'
			},
		},
	}

	const fadeIn = {
		closed: {
			opacity: 0,
			y: "10vh"
		},
		open: {
			y: 0,
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 2,
			}
		}
	}

	const slideDown = {
		closed: {
			opacity: 0,
			y: "-10vh",
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			y: 0,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: duration,
			},
		},
	}

	return (
		<div className="chapter-title">
			<div className="title-cells"></div>
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 609.92 364.78"
				variants={parentControl}
				initial="closed"
				animate={props.coverLoaded ? "open" : "closed"}
				exit="closed"
			>
				<defs>
					<clipPath id="clip-path" transform="translate(-8.94 -9.07)">
						<rect x="53" width="336" height="41" fill="none" />
					</clipPath>
					<clipPath
						id="clip-path-2"
						transform="translate(-8.94 -9.07)"
					>
						<rect
							x="446"
							y="3"
							width="121"
							height="38"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clip-path-3"
						transform="translate(-8.94 -9.07)"
					>
						<rect y="126" width="57" height="77" fill="none" />
					</clipPath>
					<clipPath
						id="clip-path-4"
						transform="translate(-8.94 -9.07)"
					>
						<rect
							x="104"
							y="250"
							width="68"
							height="74"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clip-path-5"
						transform="translate(-8.94 -9.07)"
					>
						<rect
							x="214"
							y="94"
							width="72"
							height="79"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clip-path-6"
						transform="translate(-8.94 -9.07)"
					>
						<rect
							x="334"
							y="179"
							width="59"
							height="81"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clip-path-7"
						transform="translate(-8.94 -9.07)"
					>
						<rect
							x="436"
							y="304"
							width="62"
							height="78"
							fill="none"
						/>
					</clipPath>
					<clipPath
						id="clip-path-8"
						transform="translate(-8.94 -9.07)"
					>
						<rect
							x="567"
							y="199"
							width="64"
							height="82"
							fill="none"
						/>
					</clipPath>
				</defs>
				<g id="Layer_2" data-name="Layer 2">
					<g id="Layer_1-2" data-name="Layer 1">
						<g id="future">
							<g id="group_building">
								<g clipPath="url(#clip-path)">
									<motion.g
										id="building"
										className="isolation"
										variants={slideDown}
									>
										<path
											d="M66.84,21.11c2.14.35,2.87,2,2.87,3.88v4c0,3.08-2.38,4.83-6.09,4.83H57.29V9.35h6.4c3.71,0,5.88,1.75,5.88,4.83v3.08C69.57,19,68.8,20.86,66.84,21.11Zm-5.49-1.65h2.27a1.69,1.69,0,0,0,1.89-1.89V14.74a1.69,1.69,0,0,0-1.89-1.89H61.35Zm2.41,3.43H61.35v7.46h2.41a1.7,1.7,0,0,0,1.89-1.89V24.78A1.7,1.7,0,0,0,63.76,22.89Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M116.47,29c0,3.78-2.38,5.18-6.09,5.18h-.14c-3.71,0-6.09-1.37-6.09-5.18V9.35h4.06v19c0,1.75.77,2.24,2.1,2.24s2.1-.49,2.1-2.24v-19h4.06Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M151.54,33.85V9.35h4.06v24.5Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M201.07,33.85H190.74V9.35h4.06V30.21h6.27Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M247.16,14.53V28.67c0,3.71-2.45,5.18-6.16,5.18h-6.27V9.35H241C244.71,9.35,247.16,10.82,247.16,14.53Zm-6.3-1.61H238.8V30.28h2.06c1.33,0,2.24-.49,2.24-2.24V15.16C243.1,13.41,242.19,12.92,240.86,12.92Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M282.16,33.85V9.35h4.06v24.5Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M321.36,33.85V9.35h4.06l5.15,15.15V9.35h3.71v24.5h-3.85l-5.36-15.93V33.85Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M381.74,29c0,3.78-2.45,5.18-6.17,5.18h-.28c-3.71,0-6.16-1.37-6.16-5.18V14.25c0-3.64,2.45-5.18,6.16-5.18h.28c3.72,0,6.17,1.54,6.17,5.18v3.5h-4.07V14.88c0-1.75-.91-2.24-2.24-2.24s-2.24.49-2.24,2.24V28.32c0,1.75.91,2.24,2.24,2.24s2.24-.49,2.24-2.24V24.68h-2.38V21.25h6.45Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
									</motion.g>
								</g>
							</g>
							<g id="group_the">
								<g clipPath="url(#clip-path-2)">
									<motion.g id="the" variants={slideDown}>
										<path
											d="M464.47,12.92h-4.09V33.85h-4.06V12.92h-4.1V9.35h12.25Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M502.13,9.35V19.57h4.66V9.35h4.06v24.5h-4.06V23.21h-4.66V33.85h-4.06V9.35Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
										<path
											d="M545.85,33.85V9.35h10.74v3.57h-6.68v6.72h5.6v3.57h-5.6v7.07h6.79v3.57Z"
											transform="translate(-8.94 -9.07)"
											fill="currentColor"
										/>
									</motion.g>
								</g>
							</g>
							<g id="group_future_f">
								<g clipPath="url(#clip-path-3)">
									<motion.g id="future_f" variants={fadeIn}>
										<g id="F-2" className="isolation">
											<g className="isolation">
												<path
													d="M8.94,135.85H52.85v14.4H24.68V162H50.06v14.22H24.68v22.68H8.94Z"
													transform="translate(-8.94 -9.07)"
													fill="currentColor"
												/>
											</g>
										</g>
									</motion.g>
								</g>
							</g>
							<g id="group_future_u">
								<g clipPath="url(#clip-path-4)">
									<motion.g id="future_u" variants={fadeIn}>
										<g id="U-3" className="isolation">
											<g className="isolation">
												<path
													d="M112.48,293.2V255.85h15.75V293.2c0,6.66,3.06,11.7,10.08,11.7s10-5,10-11.7V255.85h15.75V293.2c0,16.11-8.28,27-25.74,27S112.48,309.31,112.48,293.2Z"
													transform="translate(-8.94 -9.07)"
													fill="currentColor"
												/>
											</g>
										</g>
									</motion.g>
								</g>
							</g>
							<g id="group_future_t">
								<g clipPath="url(#clip-path-5)">
									<motion.g id="future_t" variants={fadeIn}>
										<g id="T-2" className="isolation">
											<g className="isolation">
												<path
													d="M243,117.43H223.33V102.85H279v14.58l-19.8.09v48.42L243,165.85Z"
													transform="translate(-8.94 -9.07)"
													fill="currentColor"
												/>
											</g>
										</g>
									</motion.g>
								</g>
							</g>
							<g id="group_future_u2">
								<g clipPath="url(#clip-path-6)">
									<motion.g id="future_u2" variants={fadeIn}>
										<g id="U-4" className="isolation">
											<g className="isolation">
												<path
													d="M337.48,228.2V190.85h15.75V228.2c0,6.66,3.06,11.7,10.08,11.7s10-5,10-11.7V190.85h15.75V228.2c0,16.11-8.28,27-25.74,27S337.48,244.31,337.48,228.2Z"
													transform="translate(-8.94 -9.07)"
													fill="currentColor"
												/>
											</g>
										</g>
									</motion.g>
								</g>
							</g>
							<g id="group_future_r">
								<g clipPath="url(#clip-path-7)">
									<motion.g id="future_r" variants={fadeIn}>
										<g id="R-2" className="isolation">
											<g className="isolation">
												<path
													d="M480,351.53l11.52,22.32H474.33l-9.27-20.07h-7.38v20.07H441.94v-63H469.2c13.59,0,22.41,8.82,22.41,21.15C491.61,340.91,487.29,348,480,351.53Zm-22.32-11.7H466c4.86,0,8.73-2.25,8.73-7.83s-3.87-7.65-8.73-7.65h-8.28Z"
													transform="translate(-8.94 -9.07)"
													fill="currentColor"
												/>
											</g>
										</g>
									</motion.g>
								</g>
							</g>
							<g id="group_future_e">
								<g clipPath="url(#clip-path-8)">
									<motion.g id="future_e" variants={fadeIn}>
										<g id="E-2" className="isolation">
											<g className="isolation">
												<path
													d="M574.94,205.85h43.91v14H590.23v10.53h25.83v13.95H590.23v10.17h28.62v14.4H574.94Z"
													transform="translate(-8.94 -9.07)"
													fill="currentColor"
												/>
											</g>
										</g>
									</motion.g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</motion.svg>
		</div>
	)
}
